import { render, staticRenderFns } from "./GalleryType2.vue?vue&type=template&id=4183f92e"
import script from "./GalleryType2.vue?vue&type=script&lang=js"
export * from "./GalleryType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4183f92e')) {
      api.createRecord('4183f92e', component.options)
    } else {
      api.reload('4183f92e', component.options)
    }
    module.hot.accept("./GalleryType2.vue?vue&type=template&id=4183f92e", function () {
      api.rerender('4183f92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/gallery/GalleryType2.vue"
export default component.exports